import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { getShopReviewsRoute } from '@services/routes.service';
import MagicHeader from '@components/MagicHeader';
import { calculateOpacities } from '@shopDetails/utils/headerOpacities';
import Header from '@shared/containers/Header';

import MainHeaderGroceries from '../components/MainHeaderGroceries/Desktop';

function DesktopShelvesMenuHeader({
  shop,
  goBack,
  match: {
    params: { city, restaurant },
  },
  subHeader,
}) {
  const reviewsRoute = useMemo(
    () => getShopReviewsRoute({ city, restaurant }),
    [city, restaurant],
  );

  return (
    <>
      <Header onGoBack={goBack} />
      <MagicHeader
        calculateOpacities={calculateOpacities}
        mainHeader={
          <MainHeaderGroceries
            shop={shop}
            reviewsRoute={reviewsRoute}
            subHeader={subHeader}
            showInputSearch={false}
          />
        }
        secondHeader={<Header onGoBack={goBack} />}
      />
    </>
  );
}

DesktopShelvesMenuHeader.propTypes = {
  shop: PropTypes.object.isRequired,
  goBack: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      city: PropTypes.string,
      restaurant: PropTypes.string,
    }),
  }).isRequired,
  subHeader: PropTypes.node,
};

export default DesktopShelvesMenuHeader;
